<template>
    <section
        class="section is-paddingless"
        :class="className"
        id="home"
    >
        <div class="container is-marginless is-fluid">
            <div class="layer layer-animation layer-1"></div>
            <div class="layer layer-animation layer-2"></div>
            <div class="layer layer-animation layer-3"></div>
            <div class="columns">
                <div class="column is-5 is-offset-1 zegar">
                    <img src="./../../assets/HomeSlider/zegar-bg.png" alt="zegar tło" class="zegar__bg">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000" class="zegar__svg">
                        <g id="zegar">
                            <path fill="#294794" d="M143.34 500C143.34 697 303 856.65 500 856.65S856.66 697 856.66 500 697 143.35 500 143.35 143.34 303 143.34 500"/>
                            <path fill="#4f7ac7" d="M146.57 500.11c0 186.28 151 337.3 337.3 337.3s337.3-151 337.3-337.3-151-337.3-337.3-337.3-337.3 151-337.3 337.3"/>
                            <path fill="#294794" d="M175.54 500.11c0 170.28 138 308.32 308.33 308.32s308.33-138 308.33-308.32-138.05-308.33-308.33-308.33-308.33 138-308.33 308.33"/>
                            <path fill="#f0f0f0" d="M189.91 500.11c0 166.31 134.83 301.14 301.14 301.14S792.2 666.42 792.2 500.11 657.37 199 491.05 199 189.91 333.79 189.91 500.11"/>
                            <path fill="#fff" d="M207.8 511.62c0 160.48 127.37 291.21 286.53 296.63 165.44-5.51 297.87-141.36 297.87-308.14a307 307 0 0 0-41.08-153.87C697.83 267 607.31 214.81 504.62 214.81c-163.93 0-296.82 132.89-296.82 296.81"/>
                            <path fill="#294794" d="M763.8 504.93a11 11 0 1 0 5.06-14.7 11 11 0 0 0-5.06 14.7M218.3 495.29a11 11 0 1 0-5.06 14.7 11 11 0 0 0 5.06-14.7M729.67 367.9a11 11 0 1 0-3-15.26 11 11 0 0 0 3 15.26M252.43 632.31a11 11 0 1 0 3 15.26 11 11 0 0 0-3-15.26M631.6 266.31a11 11 0 1 0-10.2-11.74 11 11 0 0 0 10.2 11.74M350.5 733.91a11 11 0 1 0 10.2 11.73 11 11 0 0 0-10.2-11.73M495.87 227.36a11 11 0 1 0-14.7-5.06 11 11 0 0 0 14.7 5.06M486.23 772.86a11 11 0 1 0 14.7 5.06 11 11 0 0 0-14.7-5.06M358.85 261.49a11 11 0 1 0-15.26 3 11 11 0 0 0 15.26-3M623.25 738.73a11 11 0 1 0 15.26-3 11 11 0 0 0-15.26 3M257.25 359.56a11 11 0 1 0-11.73 10.2 11 11 0 0 0 11.73-10.2M724.85 640.66a11 11 0 1 0 11.73-10.2 11 11 0 0 0-11.73 10.2"/>
								<path class="cls-5" fill="none" stroke="#4f7ac9" stroke-miterlimit="25.54" stroke-width="2px" d="M347.7,642.08l32.7-34c5.71-5.84,9.88-11.55,9.88-17.25,0-6.13-3.89-10.3-10.43-10.3-6.82,0-11.69,4.45-14.34,10.57l-18.79-11c6.27-14.47,19.35-21.29,32.85-21.29,17.39,0,33,11.41,33,31,0,11.69-6.26,21.71-15.17,30.62L381.24,636.8h32.7v21.43H347.7Z"/>
								<path class="cls-5" fill="none" stroke="#4f7ac9" stroke-miterlimit="25.54" stroke-width="2px" d="M421.6,609.52c0-30.07,14.47-50.66,39.66-50.66s39.67,20.59,39.67,50.66-14.47,50.66-39.67,50.66S421.6,639.58,421.6,609.52Zm57.06,0c0-18.79-5.7-28.95-17.4-28.95s-17.39,10.16-17.39,28.95,5.7,28.94,17.39,28.94S478.66,628.3,478.66,609.52Z"/>
								<path class="cls-5" fill="none" stroke="#4f7ac9" stroke-miterlimit="25.54" stroke-width="2px" d="M505.39,642.08l32.7-34c5.71-5.84,9.88-11.55,9.88-17.25,0-6.13-3.89-10.3-10.44-10.3-6.81,0-11.69,4.45-14.33,10.57l-18.79-11c6.26-14.47,19.35-21.29,32.85-21.29,17.39,0,33,11.41,33,31,0,11.69-6.26,21.71-15.17,30.62L538.93,636.8h32.7v21.43H505.39Z"/>
								<path class="cls-5" fill="none" stroke="#4f7ac9" stroke-miterlimit="25.54" stroke-width="2px" d="M620.07,560.8v97.43H597.8v-73.9l-17.26,4.73L575.12,570l25.46-9.19Z"/>
                        </g>
                        <g id="wskazowka_dluga" data-name="wskazowka dluga">
                            <path fill="#294794" d="M493.62 494.76L358.4 248.19a11 11 0 1 0-19.28 10.57l135.21 246.56a11 11 0 1 0 19.28-10.57z"/>
                        </g>
                        <g id="wskazowka_krotka" data-name="wskazowka krotka">
                            <path fill="#4f7ac7" d="M498.72 295.14a14.75 14.75 0 0 0-29.49 0V500a14.75 14.75 0 0 0 29.49 0z"/>
                        </g>
                    </svg>
                </div>
                <div class="column is-6">
                    <div class="slider">
                        <div
                        class="slide"
                        v-for="(slide,key) in data.slides"
                        v-bind:key="key"
                        :class="{'active':key == current}"
                        v-scroll-to="'#wyzwania-podatkowe'"
                        >
                            <div class="title"><span v-html="slide.title"></span><br /><span class="span">{{ slide.subtitle }}</span></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    data(){
        return {
            current: 0,
            timer: null

        }
    },
    methods: {
        nexSlide(){
            this.current = this.current >= this.data.slides.length-1 ? 0 : this.current+1
        },
        setSlide(slide){
            this.current = slide
            this.newTimer();
        },
        newTimer(){
            clearInterval(this.timer)
            this.timer = setInterval(() => {
                this.nexSlide()
            },4000)
        }
    },
    created(){
        this.newTimer()
    }
}
</script>

<style scoped lang="sass">
@import "@/styles/framework/variables.sass"
@import "@/styles/framework/extends.sass"
@keyframes clouds
    from
        transform: translateX(0)
    to
        transform: translateX(-50%)
@keyframes wskazowka
    from
        transform: rotate(0)
    to
        transform: rotate(360deg)
#wskazowka_dluga,
#wskazowka_krotka
    transform-origin: 48.5% 50%
    animation-name: wskazowka
    animation-iteration-count: infinite
    animation-timing-function: linear
    will-change: transform
#wskazowka_dluga
    animation-duration: 10s
#wskazowka_krotka
    animation-duration: 120s
.section
    background-color: $grey2
    overflow: hidden
    .container:first-child
        height: calc( 70vh - #{$navbar-height}
        display: flex
        align-items: center
        justify-content: center
        +mobile
            height: calc( 50vh - #{$navbar-height}
        .layer
            position: absolute
            left: 0
            top: 0
            width: 250%
            height: 100%
            z-index: -1
            &.layer-animation
                background-size: 50% auto
                background-position: bottom
                background-repeat: repeat-x
                will-change: transform
                animation-name: clouds
                animation-duration: 40s
                animation-iteration-count: infinite
                animation-timing-function: linear
            &.layer-1
                background-image: url('~@/assets/HomeSlider/clouds-1.png')
                animation-duration: 90s
                z-index: 3
            &.layer-2
                background-image: url('~@/assets/HomeSlider/clouds-2.png')
                animation-duration: 140s
                z-index: 2
            &.layer-3
                background-image: url('~@/assets/HomeSlider/clouds-3.png')
                animation-duration: 220s
                z-index: 1
        .columns
            z-index: 4
            width: 70%
            +mobile
                width: 90%
            .slider
                position: relative
                display: block
                height: 100%
                +mobile
                    height: auto
                .slide
                    cursor: pointer
                    opacity: 0
                    transform: translateY(-30px)
                    position: absolute
                    display: flex
                    justify-content: center
                    align-items: center
                    height: 100%
                    width: 100%
                    will-change: opacity, transform
                    transition: opacity $normal, transform $normal
                    &.active
                        opacity: 1
                        transform: translateY(0)
                    .title
                        +desktop
                            font-size: $size-3
                        +widescreen
                            font-size: $size-2
                        +fullhd
                            font-size: $size-1
                        .span
                            font-weight: normal
                            color: $pink
            .zegar
                position: relative
                order: 2
                +mobile
                    display: none
                &__bg
                    position: absolute
                    width: 76%
                    height: auto
                    top: 0
                    left: 0
                    z-index: -1
                    margin-top: 50px
                &__svg
                    margin-top: -60px
    .bullets
        position: relative
        display: inline-block
        width: 15px
        height: 15px
        margin: 0 8px 20px
        cursor: pointer
        z-index: 10
        &::before,
        &::after
            content: " "
            display: block
            position: absolute
            left: 0
            top: 0
            width: 100%
            height: 100%
            border-radius: 50%
            background-color: $grey1
        &::after
            background-color: $blue1
            transition: transform $fast
            transform: scale(0)
        &.active
            &::after
                transform: scale(1)

</style>
